"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Tab = _interopRequireDefault(require("./Tab.style"));

var _dec, _class;

let Tab = (_dec = (0, _reactJss.default)(_Tab.default), _dec(_class = class Tab extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.tabRef = props.forwardRef || _react.default.createRef();
  }

  handleChange(value) {
    const {
      id,
      onChange
    } = this.props;
    const error = false;
    onChange({
      id,
      value,
      error
    });
  }

  render() {
    const {
      children,
      className,
      id,
      classes,
      size,
      underline,
      value,
      type,
      tabItemIndent,
      dataTestId
    } = this.props;
    const tabClasses = (0, _clsx.default)(className, classes.tabContainer, classes[size], classes[type], {
      bottomLine: !!underline
    });
    const childrenTabs = Array.isArray(children) ? children : [children];
    const visibilityTabs = childrenTabs.filter(c => c.props.visibility !== 'hidden');
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.tabRef,
      id: id,
      className: tabClasses,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: container => this.container = container,
      className: (0, _clsx.default)(classes.tabs)
    }, _react.default.Children.map(visibilityTabs, (tab, index) => {
      const params = {
        itemRef: el => {
          this[`itemRef${tab.props.value}`] = el;
        },
        onChange: this.handleChange,
        activeItem: value,
        size,
        type,
        tabItemIndent,
        dataTestId: tab.props.dataTestId || (dataTestId ? `${dataTestId}-item-${index}` : undefined)
      };
      return _react.default.cloneElement(tab, params);
    })));
  }

}) || _class);
Tab.defaultProps = {
  id: null,
  children: null,
  value: null,
  visibility: 'visible',
  type: 'fixed',
  size: 'medium',
  tabItemIndent: 'medium',
  underline: false,
  onChange: () => {}
};
var _default = Tab;
exports.default = _default;